/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemDataTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System Data Types Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMDATATYPE_LIST_CONTAINER_LOADED = 'SYSTEMDATATYPE_LIST_CONTAINER_LOADED';
export const SYSTEMDATATYPE_LIST_CONTAINER_UNLOADED = 'SYSTEMDATATYPE_LIST_CONTAINER_UNLOADED';
export const SYSTEMDATATYPE_LIST_TABLE_LOADED = 'SYSTEMDATATYPE_LIST_TABLE_LOADED';
export const SYSTEMDATATYPE_LIST_TABLE_UNLOADED = 'SYSTEMDATATYPE_LIST_TABLE_UNLOADED';
export const SYSTEMDATATYPE_SELECT_ROW = 'SYSTEMDATATYPE_SELECT_ROW';
export const SYSTEMDATATYPE_ADD = 'SYSTEMDATATYPE_ADD';
export const SYSTEMDATATYPE_EDIT = 'SYSTEMDATATYPE_EDIT';
export const SYSTEMDATATYPE_DELETE = 'SYSTEMDATATYPE_DELETE';
export const SYSTEMDATATYPE_OPEN_WARNING = 'SYSTEMDATATYPE_OPEN_WARNING';
export const SYSTEMDATATYPE_CLOSE_WARNING = 'SYSTEMDATATYPE_CLOSE_WARNING';

export const SYSTEMDATATYPE_EDIT_CONTAINER_LOADED = 'SYSTEMDATATYPE_EDIT_CONTAINER_LOADED';
export const SYSTEMDATATYPE_EDIT_CONTAINER_UNLOADED = 'SYSTEMDATATYPE_EDIT_CONTAINER_UNLOADED';
export const SYSTEMDATATYPE_EDIT_FORM_LOADED = 'SYSTEMDATATYPE_EDIT_FORM_LOADED';
export const SYSTEMDATATYPE_EDIT_FORM_UNLOADED = 'SYSTEMDATATYPE_EDIT_FORM_UNLOADED';
export const SYSTEMDATATYPE_EDIT_DATA_LOAD = 'SYSTEMDATATYPE_EDIT_DATA_LOAD';
export const SYSTEMDATATYPE_EDIT_CONTAINER_SUBMIT = 'SYSTEMDATATYPE_EDIT_CONTAINER_SUBMIT';
export const SYSTEMDATATYPE_EDIT_CONTAINER_CANCEL = 'SYSTEMDATATYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemDataTypes.js